import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'
import {
  isLaborCompanyOrg,
  getLaborParentBidUid,
  getLaborParentBidName,
  getLaborCompanyName
} from '@/utils/bidLevelActions.js'
import {
  nestEduWorkTree,
  parseTeamWorkContent
} from '@/utils/eduWorkContent.js'

export function parseNonNegInt(value) {
  if (value === '' || value === undefined || value === null) return null
  const raw = String(value).trim()
  if (!/^(0|[1-9]\d*)$/.test(raw)) return null
  return Number(raw)
}

export function teamBoundCount(row) {
  if (!row) return 0
  const n = Number(row.boundCount != null ? row.boundCount : row.boundcount)
  return isNaN(n) || n < 0 ? 0 : n
}

export function teamOnSiteCap(row) {
  if (!row) return 0
  const bound = teamBoundCount(row)
  if (bound > 0) return bound
  const n = Number(
    row.onSiteCount != null
      ? row.onSiteCount
      : row.onsitecount != null
      ? row.onsitecount
      : 0
  )
  return isNaN(n) || n < 0 ? 0 : n
}

export function checkInNumError(value, cap) {
  const n = parseNonNegInt(value)
  if (n === null) return '签到人数必须为大于等于0的整数'
  if (cap > 0 && n > cap) {
    return '签到人数不能大于班组在场人数（' + cap + '人）'
  }
  return ''
}

export function crowdCappedByTeamMessage(recognized, cap) {
  return (
    '照片识别到' +
    recognized +
    '人，超过班组已关联人数（' +
    cap +
    '人），重置为最大人数。如需修改，请先去关联缺失人员。'
  )
}

export function inputCheckInLabel(row, hasOnSitePeople) {
  if (hasOnSitePeople) return ''
  const n = parseNonNegInt(
    row && (row.checkInNum != null ? row.checkInNum : row.checkinnum)
  )
  if (n == null || n <= 0) return ''
  return '输入签到' + n + '人'
}

const team = {
  team: {
    name: 'team',
    theme: '作业班组',
    componentTypes: ['navigate', 'check', 'tables', 'stepForm', 'dialogForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    addFun: 'team/addTeam',
    editFun: 'team/editTeam',
    getListFun: 'team/getTeamList',
    deleteFun: 'team/deleteTeam',
    detailPage: [
      {
        buttonName: '新增',
        name: 'team',
        type: 'stepForm',
        theme: 'team',
        step: 'teamInfo',
        label: '新增作业班组'
      },
      {
        buttonName: '编辑',
        name: 'team',
        type: 'stepForm',
        theme: 'team',
        step: 'teamInfo',
        label: '编辑作业班组',
        checkType: 'useRowData'
      },
      {
        buttonName: '查看',
        name: 'team',
        type: 'stepForm',
        theme: 'team',
        step: 'teamInfo',
        label: '查看作业班组',
        checkType: 'useRowData'
      },
      {
        buttonName: '去添加人员',
        type: 'cardForm',
        name: 'person',
        theme: 'person',
        step: 'personInfo',
        label: '新增人员档案',
        pageStatus: 'adminAdd'
      },
      {
        buttonName: '搜索选择作业内容',
        name: 'selectTeamWorkContent',
        type: 'dialogForm'
      }
    ],
    headButtons: setCheckButtons(['新增']),
    queryParams: {
      organUid: (params) => {
        if (isLaborCompanyOrg(params.orgType)) {
          return getLaborParentBidUid(params) || params.orgValue
        }
        return params.orgValue
      },
      upVproUid: (params) => {
        if (params.orgType === 'simPro') return params.orgValue
        if (isLaborCompanyOrg(params.orgType)) {
          return getLaborParentBidUid(params)
        }
        return ''
      },
      downVproUid: (params) => {
        return isLaborCompanyOrg(params.orgType) ? params.orgValue : ''
      },
      query: ''
    },
    selectData: (params) => {
      const fields = []
      if (!isLaborCompanyOrg(params.orgType)) {
        fields.push(
          {
            key: 'upVproUid',
            label: '所属项目标段',
            type: 'select',
            options: (item) => {
              return item.state.bidSection.subBidSection
            },
            checkByValue: true
          },
          {
            key: 'downVproUid',
            label: '所属劳务公司',
            type: 'select',
            placeholder: '请先选择项目标段后再选择',
            options: (item) => {
              return item.state.bidSection.laborCompanyNames
            },
            filterable: true,
            checkByValue: true
          }
        )
      }
      fields.push({
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '班组名称'
      })
      return fields
    },
    rowData: (params) => {
      return params.state.team.teamList.result
    },
    rowTotal: (params) => {
      return params.state.team.teamList.totalSize
    },
    columns: (params) => {
      const columns = [{ prop: 'teamName', label: '班组名称', width: '300px' }]
      if (params.orgType !== 'laborCom') {
        columns.push({
          prop: 'downVproName',
          label: '所属劳务公司',
          minWidth: '240px'
        })
      }
      columns.push(
        { prop: 'localeForemanName', label: '现场负责人', minWidth: '100px' },
        { prop: 'foremanName', label: '班组长', width: '' },
        { prop: 'foremanPhone', label: '班组长电话', width: '' },
        { prop: 'onSiteCount', label: '在场人员数量', width: '120px' },
        {
          prop: 'isExit',
          label: '在场状态',
          tag: [
            { value: '在场', label: '在场' },
            { value: '解散', label: '解散', type: 'info' },
            { value: '退场', label: '退场', type: 'danger' }
          ]
        },
        {
          label: '操作',
          buttons: setTableButtons([
            '查看',
            '编辑',
            '删除',
            '解散',
            {
              name: '关联人员',
              style: {
                border: '1px solid #67C23A',
                color: '#ffffff',
                background: '#67C23A'
              }
            }
          ]),
          width: '380px'
        }
      )
      return columns
    },
    hasPagination: true,
    deleteConfirm: '删除班组将解绑已关联人员，不会删除人员进场记录。是否继续？',
    formParams: {
      projectUid: (params) => {
        return isLaborCompanyOrg(params.orgType) ? params.orgValue : ''
      },
      downVproName: (params) => {
        return isLaborCompanyOrg(params.orgType) ? getLaborCompanyName(params) : ''
      },
      upVproName: (params) => {
        if (isLaborCompanyOrg(params.orgType)) {
          return getLaborParentBidName(params) || ''
        }
        return params.getters['user/orgName']
      },
      teamName: '',
      foremanUid: '',
      foremanName: '',
      foremanPhone: '',
      onSiteCount: 0,
      onSiteCountInput: '',
      mark: '',
      workContent: '',
      workContentText: ''
    },
    formRules: {
      projectUid: [
        {
          required: true,
          message: '请选择所属劳务公司',
          trigger: 'blur'
        }
      ],
      teamSmallName: [
        {
          required: true,
          message: '请输入班组名称',
          trigger: 'blur'
        }
      ],
      foremanName: [
        {
          required: true,
          message: '请选择或输入班组长姓名',
          trigger: 'blur'
        }
      ],
      foremanPhone: [
        {
          required: true,
          message: '请输入班组长电话',
          trigger: 'blur'
        },
        {
          pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
          message: '手机号码输入不合法',
          trigger: 'blur'
        }
      ],
      onSiteCountInput: [
        {
          validator: (params) => {
            return (rule, value, callback) => {
              if (value === '' || value === undefined || value === null) {
                callback()
                return
              }
              const n = parseNonNegInt(value)
              if (n === null) {
                callback(new Error('请输入大于等于0的整数'))
                return
              }
              const row =
                (params.state.currentRow && params.state.currentRow.team) || {}
              const bound = teamBoundCount(row)
              if (bound > 0 && n > bound) {
                callback(
                  new Error('在场人数不能大于班组关联人员数（' + bound + '人）')
                )
                return
              }
              callback()
            }
          },
          trigger: ['blur', 'change']
        }
      ]
    },
    formData: {
      card: '作业班组信息',
      bottomButtons: setFormButtons(['取消', '提交']),
      fields: [
        {
          key: 'upVproName',
          label: '所属项目标段',
          type: 'input',
          disabled: true
        },
        {
          key: (params) => {
            if (isLaborCompanyOrg(params.orgType)) return 'downVproName'
            return params.pageStatus === 'add' ? 'projectUid' : 'downVproName'
          },
          label: '所属劳务公司',
          type: (params) => {
            return isLaborCompanyOrg(params.orgType) ? 'input' : 'select'
          },
          options: (params) => {
            return params.state.bidSection.unExitLaborCompanys
          },
          disabled: (params) => {
            if (isLaborCompanyOrg(params.orgType)) return true
            return params.pageStatus === 'edit'
          },
          checkByValue: true
        },
        {
          key: 'localeForemanName',
          label: '现场负责人',
          type: 'input',
          disabled: true
        },
        {
          key: 'teamSmallName',
          label: '班组名称',
          type: 'input'
        },
        {
          key: (params) => {
            return params.pageStatus === 'check' ? 'foremanName' : 'foremanUid'
          },
          label: '班组长',
          type: (params) => {
            return params.pageStatus === 'check' ? 'input' : 'select'
          },
          placeholder:
            '先从已进场人员中搜索，没有再从人员库搜索',
          filterable: true,
          remote: true,
          clearable: true,
          optionImg: true,
          optionPerson: true,
          checkByValue: true,
          echoLabelKey: 'foremanName',
          disabled: (params) => params.pageStatus === 'check',
          options: (params) => {
            return params.state.contractor.teamForemanOptions || []
          },
          check: (params) => {
            if (params.pageStatus === 'check') return ''
            return '去添加人员'
          }
        },
        {
          key: 'foremanPhone',
          label: '班组长电话',
          type: 'input',
          placeholder: '由所选班组长自动带出',
          disabled: true
        },
        {
          type: (params) =>
            params.pageStatus === 'add' || params.pageStatus === 'edit'
              ? 'tag'
              : null,
          tagType: 'info',
          tagIcon: 'el-icon-info',
          tag:
            '班组长须从已进场人员或人员库中选择；提交时若该人员尚未进场，将自动办理当日进场并授予劳务公司管理员权限。'
        },
        {
          key: (params) => {
            return params.pageStatus === 'check' ? 'onSiteCount' : 'onSiteCountInput'
          },
          label: '在场人员数量',
          type: 'input',
          inputType: 'number',
          placeholder: (params) => {
            return params.pageStatus === 'check'
              ? ''
              : '可填0；已关联人员时不能大于关联人数'
          },
          disabled: (params) => {
            return params.pageStatus === 'check'
          }
        },
        {
          key: 'workContentText',
          label: '作业内容',
          type: 'input',
          inputType: 'textarea',
          autosize: { minRows: 3, maxRows: 8 },
          placeholder: '请搜索选择作业内容，可多选',
          disabled: true,
          check: (params) => {
            return params.pageStatus === 'check' ? null : '搜索选择作业内容'
          }
        },
        {
          key: 'mark',
          label: '备注',
          type: 'input',
          placeholder: '请输入班组驻地、主要作业内容、特点等信息，60字以内',
          inputType: 'textarea',
          autosize: { minRows: 4, maxRows: 6 }
        }
      ]
    },
    selectTeamWorkContent: {
      name: 'selectTeamWorkContent',
      title: '请搜索选择作业内容',
      width: '760px',
      formParams: {
        workContents: (params) => {
          const form = params.state.formValues.team || {}
          const parsed = parseTeamWorkContent(form.workContent)
          const labels = parsed.labels.length
            ? parsed.labels
            : parseTeamWorkContent(form.workContentText).labels
          return labels
            .map((item) => {
              if (Array.isArray(item)) {
                return item.map((part) => String(part || '').trim()).filter(Boolean)
              }
              return String(item || '')
                .split('/')
                .map((part) => part.trim())
                .filter(Boolean)
            })
            .filter((path) => path.length)
        }
      },
      formData: [
        {
          key: 'workContents',
          label: '作业内容',
          type: 'cascader',
          options: (params) => {
            return nestEduWorkTree(params.state.division.workContentAndRisk || [])
          },
          multiple: true,
          filterable: true,
          clearable: true,
          collapseTags: false,
          showAllLevels: true,
          maxTags: 10,
          emitPath: true,
          expandTrigger: 'hover',
          placeholder: '按层级选择，不展示末级教育内容；输入关键词可筛选',
          span: 20
        }
      ]
    }
  }
}
export default team
